import { useI18nContext } from '@/i18n/i18n-react';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import AudienceDeleteDialog, {
  type AudienceRemoveMode,
} from '@/components/audiences/audience-delete-dialog';

export default function AudienceDetailsHeaderActions({
  audienceName,
  deleteDialogOpen,
  onDeleteDialogOpenChange,
  removeMode,
  dependentCampaignCount,
  isLoadingDependencies,
  onRemoveConfirm,
  isSubmitting = false,
}: {
  audienceName: string;
  deleteDialogOpen: boolean;
  onDeleteDialogOpenChange: (open: boolean) => void;
  removeMode: AudienceRemoveMode;
  dependentCampaignCount: number;
  isLoadingDependencies?: boolean;
  onRemoveConfirm?: () => void | Promise<void>;
  isSubmitting?: boolean;
}) {
  const { LL } = useI18nContext();

  const handleRemoveConfirm = () => {
    onDeleteDialogOpenChange(false);
    void onRemoveConfirm?.();
  };

  return (
    <>
      <Button
        variant="ghost"
        size="auto"
        className="size-8 shrink-0 text-destructive self-end hover:text-destructive"
        aria-label={LL.audiences.details.actions.menuLabel()}
        onClick={() => onDeleteDialogOpenChange(true)}
      >
        <Trash2 data-icon="inline-start" className="size-8" />
      </Button>

      <AudienceDeleteDialog
        open={deleteDialogOpen}
        onOpenChange={onDeleteDialogOpenChange}
        audienceName={audienceName}
        mode={removeMode}
        dependentCampaignCount={dependentCampaignCount}
        isLoadingDependencies={isLoadingDependencies}
        isSubmitting={isSubmitting}
        onConfirm={handleRemoveConfirm}
      />
    </>
  );
}
